import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Tree from '../../../../components/Tree'

const styles = theme => ({
    h: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 2,
    },
})

/**
 * @typedef Category
 * @type {object}
 * @property {number} id
 * @property {string} name
 * @property {string} path
 */

/**
 * @typedef CategoriesProps
 * @type {object}
 * @property {number[]} selectedCategories
 * @property {Category[]} categories
 * @property {function} addCategory
 * @property {function} removeCategory
 * @property {string} title
 * @property {object} classes
 * @property {boolean} loading
 /

/**
 * @param {CategoriesProps} props
 */
const Categories = ({
    addCategory,
    categories,
    removeCategory,
    selectedCategories,
    title,
    classes,
    loading,
}) => {
    /**
     * @param {number} categoryId
     */
    const onCheck = categoryId => {
        if (selectedCategories.includes(categoryId)) {
            removeCategory(categoryId)
        } else {
            const categoryExists = Object.prototype.hasOwnProperty.call(
                categories,
                categoryId
            )

            if (categoryExists) {
                addCategory(categoryId)
            }
        }
    }

    const selected = selectedCategories

    return (
        <div>
            <h3 className={classes.h}>{title}</h3>
            <div>
                <Tree
                    data={categories}
                    selected={selected}
                    onCheck={onCheck}
                    rootId={1168}
                    loading={loading}
                />
            </div>
        </div>
    )
}

Categories.propTypes = {
    addCategory: PropTypes.func.isRequired,
    categories: PropTypes.objectOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
        })
    ).isRequired,
    removeCategory: PropTypes.func.isRequired,
    selectedCategories: PropTypes.arrayOf(PropTypes.number).isRequired,
    title: PropTypes.string,
    loading: PropTypes.bool.isRequired,
}

Categories.defaultProp = {
    title: 'Lista kategorii',
    loading: false,
}

export default withStyles(styles, { withTheme: true })(Categories)
